<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :hasInstructions="instruction.display"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
  >
    <v-card flat max-width="500" class="pt-4">
      <report-image-upload
        :asset="asset"
        :example="example"
        :instruction="instruction"
        :type="type"
        textAlt="report.additionalImage.textBtnAlt"
      />
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import ReportImageUpload from "./ReportImageUpload.vue";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportModule } from "@/store/modules/report.store";
import { AssetEnum } from "@/lib/AssetRepository";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload
  }
})
export default class ReportCompletionImage extends ReportStepMixin implements IReportStep {
  asset = AssetEnum.carFrontRightOutline;
  example = AssetEnum.carFrontLeft;

  header: IReportHeaderData = {
    title: "report.completion.title",
    description: "report.completion.description"
  };

  instruction: IReportInstructionData = {
    title: $t("report.completion.instruction.title"),
    text: $t("report.completion.instruction.description"),
    pictures: [AssetEnum.overview],
    example: AssetEnum.overview,
    display: true
  };

  screen = ReportScreenEnum.COMPLETION;

  valid = false;

  get isDone() {
    return this.files.length > 0;
  }

  get type() {
    return ReportImageType.completion;
  }

  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter((image) => image.type === this.type);
  }
}
</script>
<style scoped>
.center {
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
